
import AuthenticatorAppService from "../../../application/platform/security/authenticator-app-service";
import { useBaseLayoutController } from "../../base-layout/context/base-layout-controller";
import { ACTION_TYPES, useProfileDispatch, useProfileState } from "./profile-context";

export const useProfileController = () => {
    const { showMessage, showBackDrop } = useBaseLayoutController();
    const { userProfileResponse, changePasswordRequest, userUpdateProfileRequest } = useProfileState();
    const profileDispatch = useProfileDispatch();

    const getInit = async () => {
        showBackDrop(true);
        var result = await AuthenticatorAppService.listStates();
        profileDispatch({
            type: ACTION_TYPES.setListStateResponse,
            payload: result,
        });
        await getProfile();
        showBackDrop(false);
    }

    const listCities = async () => {
        var result = await AuthenticatorAppService.listCities({ stateId: userProfileResponse?.stateId });
        profileDispatch({
            type: ACTION_TYPES.setListCityResponse,
            payload: result,
        });
    }
    const getProfile = async () => {
        var result = await AuthenticatorAppService.getUserProfile();

        profileDispatch({
            type: ACTION_TYPES.setUserProfileResponse,
            payload: result,
        });

        profileDispatch({
            type: ACTION_TYPES.setUserUpdateProfileRequest,
            payload: result,
        });

    }

    const updateProfile = async () => {
        if (validFields()) {

            showBackDrop(true);
            await AuthenticatorAppService.updateProfile(userUpdateProfileRequest);
            showMessage({ type: 'success', message: 'Perfil salvo com sucesso.' });
            getInit();
            showBackDrop(false);
        } else {
            showMessage({ type: 'error', message: 'É necessário preencher todos os campos obrigtórios.' });

        }
    }

    function handleOnChange(e: any) {

        let cityId = userUpdateProfileRequest?.cityId;
        let document = userUpdateProfileRequest?.document;
        let zipCode = userUpdateProfileRequest?.zipCode;
        let name = userUpdateProfileRequest?.name;
        let complement = userUpdateProfileRequest?.complement;
        let neighborhood = userUpdateProfileRequest?.neighborhood;
        let number = userUpdateProfileRequest?.number;
        let referencePoint = userUpdateProfileRequest?.referencePoint;
        let stateId = userUpdateProfileRequest?.stateId;
        let street = userUpdateProfileRequest?.street;

        if (e.target.name === "input-document") {
            document = e.target.value;
        } if (e.target.name === "input-zipcode") {
            zipCode = e.target.value;
        }
        if (e.target.name === "select-city") {
            cityId = e.target.value;
        }
        if (e.target.name === "select-state") {
            stateId = e.target.value;
        }
        if (e.target.name === "input-name") {
            name = e.target.value;
        }
        if (e.target.name === "input-complement") {
            complement = e.target.value;
        }
        if (e.target.name === "input-neighborhood") {
            neighborhood = e.target.value;
        }
        if (e.target.name === "input-number") {
            number = e.target.value;
        }
        if (e.target.name === "input-referencePoint") {
            referencePoint = e.target.value;
        }
        if (e.target.name === "input-street") {
            street = e.target.value;
        }

        profileDispatch({
            type: ACTION_TYPES.setUserUpdateProfileRequest,
            payload: { ...userUpdateProfileRequest, street, referencePoint, number, neighborhood, zipCode, complement, name, document, stateId, cityId },
        });
    };


    function validFields() {
        let isValid = true;

        if (userUpdateProfileRequest?.name === undefined || userUpdateProfileRequest.name === null) {
            isValid = false;
        }

        if (userUpdateProfileRequest?.document === undefined || userUpdateProfileRequest.document === null) {
            isValid = false;
        }
        if (userUpdateProfileRequest?.zipCode !== undefined && userUpdateProfileRequest?.zipCode !== null) {
           if (userUpdateProfileRequest?.street === undefined || userUpdateProfileRequest.street === null)
                isValid = false;
            if (userUpdateProfileRequest?.neighborhood === undefined || userUpdateProfileRequest.neighborhood === null)
                isValid = false;
            if (userUpdateProfileRequest?.stateId === undefined || userUpdateProfileRequest.stateId === null)
                isValid = false;
            if (userUpdateProfileRequest?.cityId === undefined || userUpdateProfileRequest.cityId === null)
                isValid = false;
        }
        profileDispatch({
            type: ACTION_TYPES.setFieldIsValid,
            payload: isValid,
        });

        return isValid;
    }
    return {
        handleOnChange, getInit, listCities, updateProfile
    };
}